import React from "react";
import { useEffect } from "react";

import "../Styles/Nav.css";

import { Link } from "react-router-dom";

import axios from "axios";

import Cookies from 'js-cookie';

export default function Nav(props) {
    const [isDropdown, setIsDropdown] = React.useState(false);
    const [isPortrait, setIsPortrait] = React.useState(matchMedia('(orientation: portrait)').matches);
    const [createPermission, setCreatePermission] = React.useState(false);
    const token  = Cookies.get("token");

    function toggleDropdown(e) {
        setIsDropdown(!isDropdown);
        e.target.innerText = isDropdown ? "☰" : "✖";
    }
    function closeDropdown(e) {
        if (isDropdown) {
            setIsDropdown(false);
            document.querySelector(".dropbtn").innerText = "☰";
        }
    }

    useEffect(() => (
        window.addEventListener('resize', ()=>{setIsPortrait(matchMedia('(orientation: portrait)').matches)})
      ),[])
    
    useEffect(() => {
        if (Cookies.get("token") !== undefined) {
            axios.get("https://anatole-sot.xyz/api/recettes-gibli/get-permission.php", {
                params: {
                    token: Cookies.get("token"),
                    perm: "Create"
                }
            })
            .then((response) => {
                if (response.data.status === "success") {
                    setCreatePermission(true);
                }
            })
        }
    },[token])
    if (isPortrait) {
        return (
            <nav>
                <div className={(!isDropdown?"hide ":"")+"dropdown"} onClick={closeDropdown}>
                    <button className="dropbtn" onClick={toggleDropdown}>☰</button>
                    <div className={"dropcontent "}>
                        <ul>
                            {
                            props.routes.map((route, index) => (
                                    (Cookies.get("token") !== undefined && route.inNav && route.whenConnected && (route.permissions === undefined || (route.permissions === "Create" && createPermission))) || (Cookies.get("token") === undefined && route.inNav && route.whenDisconnected) ? 
                                    (<li key={index}>
                                        <Link to={route.path}>{route.display}</Link>
                                    </li>)
                                    : 
                                    null
                                ))
                            }
                        </ul>
                    </div>
                </div>
            </nav>
        );
    } else {
        return (
            <nav>
                <ul>
                    {
                    props.routes.map((route, index) => (
                            (Cookies.get("token") !== undefined && route.inNav && route.whenConnected && (route.permissions === undefined || (route.permissions === "Create" && createPermission))) || (Cookies.get("token") === undefined && route.inNav && route.whenDisconnected) ? 
                            (<li key={index}>
                                <Link to={route.path}>{route.display}</Link>
                            </li>)
                            : 
                            null
                        ))
                    }
                </ul>
            </nav>
        );
    }
}